<ng-container
  *ngIf="{
    tabItems: tabItems$ | async,
    fixedItems: fixedItems$ | async,
    additionalItems: additionalItems$ | async
  } as data"
>
  <avano-tabs-header
    #avanoHeader
    class="tabs-header"
    [selectedId]="selectedId"
    (tabClosed)="closeTab($event, data.tabItems)"
    (selectFocusedIndex)="selectedId = $event"
  >
    <ng-container allTabs>
      <li *ngFor="let item of data.tabItems" class="tabs-menu-item" (click)="selectedId = item.tabId">
        <i *ngIf="item?.leftIcon" [class]="item.leftIcon"></i>
        <span class="label-text">{{ item.isLoading ? (sharedTranslationKeys.tabsComponent.html.tab.loading | translate) : item.label }}</span>
        <i *ngIf="item.isUnsaved" class="icon-content-unread"></i>
        <i *ngIf="item.closable" class="icon-content-close" (click)="item.close($event); $event.stopPropagation()"></i>
      </li>
    </ng-container>
    <ng-container fixedTabs>
      <div
        class="tab-label-container fixed"
        *ngFor="let item of data.fixedItems"
        cdkMonitorElementFocus
        avanoTabLabelWrapper
        [id]="item.tabId"
        [label]="item?.label"
        [isUnsaved]="item?.isUnsaved"
        [closable]="item?.closable"
        [attr.tabIndex]="getTabIndex(item.tabId)"
        [attr.title]="item.label"
        (cdkFocusChange)="tabFocusChanged($event, item.tabId)"
        (click)="selectedId = item.tabId"
      >
        <div class="tab-label default-label" [class.active]="selectedId === item.tabId">
          <i *ngIf="item?.leftIcon" [class]="item.leftIcon"></i><span class="label-text">{{ item.label }}</span>
          <i *ngIf="item.isUnsaved" class="icon-content-unread"></i>
          <i *ngIf="item.closable" class="icon-content-close" (click)="item.close($event); $event.stopPropagation()"></i>
        </div>
      </div>
    </ng-container>
    <div
      class="tab-label-container additional"
      cdkMonitorElementFocus
      avanoTabLabelWrapper
      [id]="item.tabId"
      [label]="item?.label"
      [isUnsaved]="item?.isUnsaved"
      [closable]="item?.closable"
      [attr.tabIndex]="getTabIndex(item.tabId)"
      [attr.title]="item.label"
      *ngFor="let item of data.additionalItems"
      (click)="selectedId = item.tabId"
      (cdkFocusChange)="tabFocusChanged($event, item.tabId)"
    >
      <div class="tab-label default-label" [class.active]="selectedId === item.tabId">
        <i *ngIf="item?.leftIcon" [class]="item.leftIcon"></i>
        <span class="label-text">{{ item.isLoading ? (sharedTranslationKeys.tabsComponent.html.tab.loading | translate) : item.label }}</span>
        <i *ngIf="item.isUnsaved" class="icon-content-unread"></i>
        <i *ngIf="item.closable" class="icon-content-close" (click)="item.close($event); $event.stopPropagation()"></i>
      </div>
    </div>
  </avano-tabs-header>

  <div class="tabs-body">
    <ng-container *ngFor="let item of data.tabItems">
      <div [hidden]="selectedId !== item?.tabId">
        <ng-container [ngTemplateOutlet]="item.buttonBarContent?.templateRef"></ng-container>
        <ng-container [ngTemplateOutlet]="item.bodyContent.templateRef"> </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
